/**
 * The persisted browser anonymous id used for signup analytics and public
 * feature-flag rollout bucketing. Both the Hydra shell and the embedded app
 * read the same localStorage key, so a visitor buckets identically whichever
 * app serves the funnel.
 */
export const SIGNUP_ANONYMOUS_ID_STORAGE_KEY = 'cio:anonymous-id';

export function getOrCreateSignupAnonymousId(): string {
  const existing = localStorage.getItem(SIGNUP_ANONYMOUS_ID_STORAGE_KEY);
  if (existing != null && existing !== '') {
    return existing;
  }

  const id = crypto.randomUUID();
  localStorage.setItem(SIGNUP_ANONYMOUS_ID_STORAGE_KEY, id);
  return id;
}
